// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--1h1Eh","text":"hero-module--text--1qCBX","more":"hero-module--more--3JHjE","innerWrapper":"hero-module--inner-wrapper--2T30O"};